import { forwardRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell, CheckCheck, Loader2 } from "lucide-react";
import { fmtHora } from "@/components/alerts/AlertLists";
import { AlertsTabs } from "@/components/alerts/AlertsTabs";
import { useAlerts } from "@/components/alerts/useAlerts";

// forwardRef + spread: necessário para funcionar como filho de PopoverTrigger asChild
const BellTrigger = forwardRef(function BellTrigger({ total, ...props }, ref) {
  const hasAny = total > 0;
  return (
    <Button
      ref={ref}
      {...props}
      variant="ghost"
      size="icon"
      className="relative text-white hover:bg-white/10 shrink-0"
      data-testid="btn-alerts-bell"
      aria-label="Alertas"
    >
      <Bell className={`w-5 h-5 ${hasAny ? "animate-wiggle" : ""}`} />
      {hasAny && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center px-1 border-2 border-[#083CA6]"
          data-testid="alerts-badge-count"
        >
          {total > 99 ? "99+" : total}
        </span>
      )}
    </Button>
  );
});

export default function AlertsBell() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const alerts = useAlerts();

  const abrirInscricao = (iid) => { setOpen(false); nav(`/admin/inscricoes/${iid}`); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <BellTrigger total={alerts.totalBadge} />
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[380px] p-0" data-testid="alerts-popover">
        <div className="flex items-center justify-between p-3 border-b bg-slate-50">
          <div className="font-bold text-sm text-[#083CA6] flex items-center gap-2">
            <Bell className="w-4 h-4" /> Alertas
            {alerts.loading && <Loader2 className="w-3 h-3 animate-spin text-slate-400" />}
          </div>
          <Button
            size="sm"
            variant="ghost"
            className="h-7 text-xs"
            onClick={alerts.marcarVistas}
            disabled={alerts.novasNovas.length === 0 || alerts.marking}
            data-testid="btn-marcar-vistas"
            title="Marcar inscrições novas como vistas"
          >
            <CheckCheck className="w-3.5 h-3.5 mr-1" /> Marcar vistas
          </Button>
        </div>

        <AlertsTabs
          data={alerts.data}
          seenAt={alerts.seenAt}
          novasCount={alerts.novasNovas.length}
          docsCount={alerts.docsCount}
          otpsCount={alerts.otpsCount}
          onOpen={abrirInscricao}
        />

        <div className="p-2 border-t bg-slate-50 text-[10px] text-center text-slate-500">
          Atualiza automaticamente a cada 60s · Última: {alerts.data?.generated_at ? fmtHora(alerts.data.generated_at) : "—"}
        </div>
      </PopoverContent>
    </Popover>
  );
}
